import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const QUERY = gql`
  query units {
    units {
      sign
      name
    }
  }
`;

const useUnits = () => {
  const { loading, error, data, refetch } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  return { loading, error, refetch, data: data?.units };
};

export default useUnits;
